import { render, staticRenderFns } from "./UpdateQuestionModal.vue?vue&type=template&id=5ad497fd&scoped=true&"
import script from "./UpdateQuestionModal.vue?vue&type=script&lang=js&"
export * from "./UpdateQuestionModal.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad497fd",
  null
  
)

export default component.exports